/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiateRefundResponse
 */
export interface InitiateRefundResponse {
    /**
     * 
     * @type {string}
     * @memberof InitiateRefundResponse
     */
    softpayRequestId: string;
}

/**
 * Check if a given object implements the InitiateRefundResponse interface.
 */
export function instanceOfInitiateRefundResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "softpayRequestId" in value;

    return isInstance;
}

export function InitiateRefundResponseFromJSON(json: any): InitiateRefundResponse {
    return InitiateRefundResponseFromJSONTyped(json, false);
}

export function InitiateRefundResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateRefundResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'softpayRequestId': json['softpayRequestId'],
    };
}

export function InitiateRefundResponseToJSON(value?: InitiateRefundResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'softpayRequestId': value.softpayRequestId,
    };
}

